var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatasets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0277 7.78652L50.761 14.7732C55.2944 16.7732 55.2944 20.0799 50.761 22.0799L35.0277 29.0665C33.241 29.8665 30.3077 29.8665 28.521 29.0665L12.7877 22.0799C8.25436 20.0799 8.25436 16.7732 12.7877 14.7732L28.521 7.78652C30.3077 6.98652 33.241 6.98652 35.0277 7.78652Z",
    fill: "#5679EC",
    stroke: "#5679EC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 29.333C8.33398 31.573 10.014 34.1597 12.0673 35.0663L30.174 43.1197C31.5607 43.733 33.134 43.733 34.494 43.1197L52.6007 35.0663C54.654 34.1597 56.334 31.573 56.334 29.333",
    stroke: "#3C55A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 42.667C8.33398 45.147 9.80065 47.387 12.0673 48.4003L30.174 56.4537C31.5607 57.067 33.134 57.067 34.494 56.4537L52.6007 48.4003C54.8673 47.387 56.334 45.147 56.334 42.667",
    stroke: "#5679EC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasets);
export default __webpack_public_path__ + "static/media/datasets.d04d849d.svg";
export { ForwardRef as ReactComponent };